import { AnySchema, object, ObjectSchema } from 'yup';

import {
	basicInformationFields,
} from '@components/routes/AdminPanel/KpiAlertsManagement/AddNewKpiAlertRule/AddKpiAlertBasicInformation/schema';
import {
	channelFields,
} from '@components/routes/AdminPanel/KpiAlertsManagement/AddNewKpiAlertRule/AddKpiAlertChannel/schema';
import {
	checkForFields,
} from '@components/routes/AdminPanel/KpiAlertsManagement/AddNewKpiAlertRule/AddKpiAlertCheckFor/schema';
import {
	conditionFields,
} from '@components/routes/AdminPanel/KpiAlertsManagement/AddNewKpiAlertRule/AddKpiAlertCondition/schema';
import {
	recipientFields,
} from '@components/routes/AdminPanel/KpiAlertsManagement/AddNewKpiAlertRule/AddKpiAlertRecipient/schema';
import {
	scheduleFields,
} from '@components/routes/AdminPanel/KpiAlertsManagement/AddNewKpiAlertRule/AddKpiAlertSchedule/schema';

import { IKpiAlertSchema } from './interfaces';

export const schema: ObjectSchema<Record<keyof IKpiAlertSchema, AnySchema>> = object().shape({
	...basicInformationFields,
	...checkForFields,
	...conditionFields,
	...scheduleFields,
	...recipientFields,
	...channelFields,
});
